// The pure helpers of the Bot Reports pages: the addresses the API is asked for, and the small pieces of text a list
// row or a report header shows. No React, so they can be unit tested.

// The API returns at most 200 reports in one list, newest first.
export const LIST_LIMIT = 200;

// The address of the report list. Only the filters that are set go into it.
export const reportsUrl = ({ account, botId, from, to, limit } = {}) => {
  const q = new URLSearchParams();
  if (account) q.set('account', account);
  if (botId) q.set('botId', botId);
  if (from) q.set('from', from);
  if (to) q.set('to', to);
  q.set('limit', String(limit || LIST_LIMIT));
  return `cma/botreport?${q.toString()}`;
};

// The address of one whole report (the list never carries the markdown).
export const reportUrl = (id) => `cma/botreport?id=${encodeURIComponent(id)}`;

// The page address of one report.
export const reportPath = (id) => `/botreports/${encodeURIComponent(id)}`;

// A report saved before the bot finished is marked complete = false; anything else counts as complete.
export const isComplete = (report) => report?.complete !== false;

// The bots that wrote the listed reports, for the Bot filter: each once, sorted.
export const botOptions = (items) =>
  [...new Set((items || []).map(r => r?.botId).filter(Boolean))].sort((a, b) => a.localeCompare(b));

// "2026-10-21T14:05:09.123Z" in the viewer's own time zone; '' when there is no usable time.
export const formatCreated = (iso) => {
  if (!iso) return '';
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? '' : d.toLocaleString();
};

// The reports whose title, bot, account, device type or requester contains the text (case-insensitive).
export const searchReports = (items, text) => {
  const wanted = (text || '').trim().toLowerCase();
  const list = items || [];
  if (!wanted) return list;
  return list.filter(r => [r.title, r.botId, r.account, r.deviceType, r.requestedBy]
    .some(v => String(v || '').toLowerCase().includes(wanted)));
};

// What the bot recorded about how it was run (the report's `ai` object), as label/value rows. Only plain values are
// shown; anything nested is left out rather than printed as [object Object].
export const aiRows = (ai) => {
  if (!ai || typeof ai !== 'object' || Array.isArray(ai)) return [];
  return Object.entries(ai)
    .filter(([, v]) => v !== null && v !== '' && ['string', 'number', 'boolean'].includes(typeof v))
    .map(([label, value]) => ({ label, value: String(value) }));
};

// A file name for saving the report's markdown: <account>-<bot>-<date>.md, safe on every file system.
export const reportFileName = (report) => {
  const day = (report?.createdUtc || '').slice(0, 10);
  const parts = [report?.account, report?.botId, day].filter(Boolean).join('-');
  return `${(parts || 'bot-report').replace(/[^A-Za-z0-9._-]+/g, '_')}.md`;
};
